import { LogFirebase } from "../../../../../services/firestore";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { setRemoteParticipanteAudioVideoStatus } from "../../../Room/roomFunction";

export const trackPublishedInRoomEvent = (publication, participant) => {
    if (publication) {
        LogFirebase("TwilioEvents", "trackPublishedInRoom", {
            track_details: publication.kind,
            participant_details: participant.identity,
        });
        if (participant.identity != CALL_DATA.localIdentity) {
            if (publication.kind == "audio") {
                if (GLOBAL_MEETING_DATA.ucid) {
                    setRemoteParticipanteAudioVideoStatus("audio", participant.identity, publication.isTrackEnabled);
                }
            }
            if (publication.kind == "video") {
                const str = publication.trackName;
                const fristLtr = str.charAt(0);
                if (fristLtr != "s") {
                    if (GLOBAL_MEETING_DATA.ucid) {
                        setRemoteParticipanteAudioVideoStatus("video", participant.identity, true);
                    }
                } else if (GLOBAL_MEETING_DATA.ucid) {
                    setRemoteParticipanteAudioVideoStatus("video", participant.identity, false);
                }
            }
        }
    }
};
